<template>
    <div class="main">
        <c-panel title="ENTRADA DE ESTOQUE" titleIcon="fas fa-arrow-down">
            <el-form label-position="top" :model="form" ref="form" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10" :md="8">
                        <el-form-item label="Instituição" prop="instituicao_id" :rules="[$requiredChange]">
                            <el-select v-if="ehSmed" v-model="form.instituicao_id" filterable placeholder="Selecione"
                                style="width:100%;" @change="limparProduto">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                            <el-input v-else :value="nomeInstituicao" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="7" :md="5">
                        <el-form-item label="Data">
                            <el-date-picker v-model="form.data_movimento" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7" :md="6">
                        <el-form-item label="Fornecedor">
                            <el-select v-model="form.fornecedor_id" filterable clearable placeholder="Selecione"
                                style="width:100%;">
                                <el-option v-for="f in fornecedores" :key="f.id" :label="f.nome" :value="f.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="5">
                        <el-form-item label="Documento (NF)">
                            <el-input v-model="form.documento" maxlength="60"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="5">
                        <el-form-item label="Grupo">
                            <el-select v-model="grupoId" filterable clearable placeholder="Todos" style="width:100%;"
                                @change="trocarGrupo">
                                <el-option label="Todos" value=""></el-option>
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="7">
                        <el-form-item label="Produto" prop="produto_id" :rules="[$requiredChange]">
                            <el-select v-model="form.produto_id" filterable remote clearable :remote-method="buscarProduto"
                                :loading="buscando" placeholder="Digite o nome ou o código" style="width:100%;"
                                @change="selecionarProduto">
                                <el-option v-for="p in produtos" :key="p.id" :label="rotuloProduto(p)" :value="p.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="8" :sm="4" :md="2">
                        <el-form-item label="Saldo atual">
                            <el-input :value="produto ? formataQtd(produto.saldo) : ''" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="8" :sm="4" :md="3">
                        <el-form-item label="Quantidade">
                            <el-input v-model="form.quantidade" @input="digitarQuantidade"
                                @keyup.enter.native="salvar" placeholder="0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="8" :sm="4" :md="3">
                        <el-form-item label="Valor unitário">
                            <el-input v-model="form.valor_unitario" @input="digitarValor"
                                @keyup.enter.native="salvar" placeholder="0,00">
                                <template slot="prepend">R$</template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4" :md="3">
                        <el-form-item label="Total">
                            <el-input :value="totalTexto" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4" :md="2">
                        <el-form-item>
                            <el-button class="u-mt-20" type="primary" @click="salvar" style="width:100%;">DAR ENTRADA</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10" v-if="produto && produto.controla_lote">
                    <el-col :xs="12" :sm="6" :md="4">
                        <el-form-item label="Lote">
                            <el-input v-model="form.lote" maxlength="60"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6" :md="4">
                        <el-form-item label="Validade">
                            <el-date-picker v-model="form.validade" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>

        <c-panel title="ÚLTIMAS ENTRADAS" titleIcon="fas fa-history">
            <div class="container-table" v-loading="carregando">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:100px;">Data</th>
                            <th>Produto</th>
                            <th>Instituição</th>
                            <th style="width:130px;">Documento</th>
                            <th style="width:110px;" class="u-text-center">Quantidade</th>
                            <th style="width:120px;" class="u-text-right">Valor unit.</th>
                            <th style="width:120px;" class="u-text-right">Total</th>
                            <th v-if="podeEditar" style="width:80px;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="m in movimentos" :key="m.id">
                            <td>{{ formataData(m.data_movimento) }}</td>
                            <td>{{ m.produto ? m.produto.nome : '—' }}</td>
                            <td>{{ m.instituicao ? m.instituicao.nome : '—' }}</td>
                            <td>{{ m.documento || '—' }}</td>
                            <td class="u-text-center">{{ formataQtd(m.quantidade) }}</td>
                            <td class="u-text-right">{{ m.valor_unitario ? formataDinheiro(m.valor_unitario) : '—' }}</td>
                            <td class="u-text-right">
                                {{ m.valor_unitario ? formataDinheiro(m.valor_unitario * m.quantidade) : '—' }}
                            </td>
                            <td v-if="podeEditar" class="u-text-center">
                                <el-button type="text" icon="el-icon-edit" title="Editar entrada" @click="abrirEdicao(m)"></el-button>
                                <el-button type="text" icon="el-icon-delete" title="Excluir entrada" style="color:#f56c6c;" @click="abrirExclusao(m)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!movimentos.length">
                            <td :colspan="podeEditar ? 8 : 7" class="u-text-center" style="color:#909399; padding:12px;">Nenhuma entrada registrada.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </c-panel>

        <el-dialog title="Editar entrada de estoque" :visible.sync="edicao.aberto" width="720px" append-to-body>
            <div v-if="edicao.mov">
                <p class="u-mb-10"><strong>{{ edicao.mov.produto ? edicao.mov.produto.nome : '' }}</strong>
                    - {{ edicao.mov.instituicao ? edicao.mov.instituicao.nome : '' }}</p>
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Data">
                                <el-date-picker v-model="edicao.form.data_movimento" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Documento (NF)">
                                <el-input v-model="edicao.form.documento" maxlength="60"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Fornecedor">
                                <el-select v-model="edicao.form.fornecedor_id" filterable clearable placeholder="Selecione" style="width:100%;">
                                    <el-option v-for="f in fornecedores" :key="f.id" :label="f.nome" :value="f.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Quantidade">
                                <el-input v-model="edicao.form.quantidade" @input="v => edicao.form.quantidade = aplicarMascaraQtd(v)"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Valor unitário">
                                <el-input v-model="edicao.form.valor_unitario" @input="v => edicao.form.valor_unitario = aplicarMascaraDinheiro(v)">
                                    <template slot="prepend">R$</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8">
                            <el-form-item label="Total">
                                <el-input :value="totalEdicao" disabled></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" v-if="edicao.mov.produto && edicao.mov.produto.controla_lote">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Lote"><el-input v-model="edicao.form.lote" maxlength="60"></el-input></el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Validade">
                                <el-date-picker v-model="edicao.form.validade" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="Observação">
                        <el-input v-model="edicao.form.observacao" type="textarea" :rows="2"></el-input>
                    </el-form-item>
                    <el-form-item label="Motivo da alteração *">
                        <el-input v-model="edicao.motivo" type="textarea" :rows="2" placeholder="Ex.: NF digitada errada"></el-input>
                    </el-form-item>
                </el-form>

                <div v-if="edicao.historico.length" class="u-mt-10">
                    <strong>Alterações anteriores</strong>
                    <table class="table table-striped u-mt-10">
                        <thead><tr><th>Quando</th><th>Quem</th><th>Campo</th><th>De</th><th>Para</th><th>Motivo</th></tr></thead>
                        <tbody>
                            <tr v-for="h in edicao.historico" :key="h.id">
                                <td>{{ $moment(h.created_at).format('DD/MM/YYYY HH:mm') }}</td>
                                <td>{{ h.usuario || '—' }}</td>
                                <td>{{ rotuloCampo(h.campo) }}</td>
                                <td>{{ h.valor_anterior || '—' }}</td>
                                <td>{{ h.valor_novo || '—' }}</td>
                                <td>{{ h.motivo }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <span slot="footer">
                <el-button @click="edicao.aberto = false">CANCELAR</el-button>
                <el-button type="primary" :loading="edicao.salvando" @click="salvarEdicao()">SALVAR ALTERAÇÃO</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Excluir entrada de estoque" :visible.sync="exclusao.aberto" width="520px" append-to-body>
            <div v-if="exclusao.mov">
                <p>Excluir a entrada de <strong>{{ formataQtd(exclusao.mov.quantidade) }}</strong> x
                    <strong>{{ exclusao.mov.produto ? exclusao.mov.produto.nome : '' }}</strong>
                    (documento {{ exclusao.mov.documento || '—' }}, {{ formataData(exclusao.mov.data_movimento) }})?</p>
                <p class="u-mt-10" style="color:#909399;">A quantidade sai do estoque. Só é possível se esse estoque ainda existir, isto é, se nada dele foi utilizado.</p>
                <el-form label-position="top" class="u-mt-10">
                    <el-form-item label="Motivo da exclusão *">
                        <el-input v-model="exclusao.motivo" type="textarea" :rows="2" placeholder="Ex.: lançada em duplicidade"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer">
                <el-button @click="exclusao.aberto = false">CANCELAR</el-button>
                <el-button type="danger" :loading="exclusao.salvando" @click="confirmarExclusao()">EXCLUIR ENTRADA</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
/** Entrada de estoque: material chegando na instituição, normalmente por nota fiscal. */
export default {
    data: () => ({
        carregando: false,
        buscando: false,
        grupos: [],
        fornecedores: [],
        produtos: [],
        produto: null,
        grupoId: '',
        movimentos: [],
        exclusao: { aberto: false, salvando: false, mov: null, motivo: '' },
        edicao: { aberto: false, salvando: false, mov: null, form: {}, orig: {}, motivo: '', historico: [] },
        form: {
            instituicao_id: '', produto_id: null, quantidade: '', valor_unitario: '', data_movimento: '',
            fornecedor_id: null, documento: '', lote: '', validade: null
        }
    }),
    computed: {
        /** Só a SEDUC (6) e o NTI (4) editam uma entrada já lançada; o servidor confere de novo. */
        podeEditar () { return [4, 6].includes(Number(this.$store.state.user.tipo)) },
        totalEdicao () {
            const qtd = this.numero(this.edicao.form.quantidade)
            const valor = this.numeroDinheiro(this.edicao.form.valor_unitario)
            return qtd > 0 && valor > 0 ? this.formataDinheiro(qtd * valor) : ''
        },
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        nomeInstituicao () { return this.$store.state.config.instituicao.nome || '-' },
        /** A store guarda as instituições como objeto; normalizar evita surpresa. */
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        },
        /** Confere a conta antes de gravar: quantidade errada aparece no total. */
        totalTexto () {
            const qtd   = this.numero(this.form.quantidade)
            const valor = this.numeroDinheiro(this.form.valor_unitario)

            return qtd > 0 && valor > 0 ? this.formataDinheiro(qtd * valor) : ''
        }
    },
    mounted () {
        this.form.data_movimento = this.$moment().format('YYYY-MM-DD')
        if (!this.ehSmed) this.form.instituicao_id = this.$store.state.config.instituicao.id
        this.carregarGrupos()
        this.carregarFornecedores()
        this.carregarMovimentos()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },
        aviso (msg) { window.eventBus.$emit('alert', { msg, type: 'warning' }) },
        formataQtd (v) { const n = Number(v) || 0; return n % 1 === 0 ? String(n) : n.toFixed(3) },
        /**
         * Quantidade aceita fração (1,5 kg), então a máscara não é posicional como
         * a do dinheiro: filtra o que é digitado, mantendo dígitos e uma vírgula.
         * Ponto vira vírgula, para quem digita no teclado numérico.
         */
        digitarQuantidade () {
            this.form.quantidade = this.aplicarMascaraQtd(this.form.quantidade)
        },
        aplicarMascaraQtd (valor) {
            const texto = String(valor === null || valor === undefined ? '' : valor)
                .replace(/\./g, ',')
                .replace(/[^\d,]/g, '')

            const partes  = texto.split(',')
            // Zeros à esquerda só saem quando há outro dígito depois: "0," continua "0,".
            const inteiro = partes.shift().replace(/^0+(?=\d)/, '').slice(0, 9)

            if (!partes.length) return inteiro

            // A coluna guarda três casas; digitar mais só criaria arredondamento
            // silencioso na gravação.
            return (inteiro || '0') + ',' + partes.join('').slice(0, 3)
        },
        /** Quantidade: aceita 1,5 e 1.5 — o operador digita como está acostumado. */
        numero (v) {
            const n = Number(String(v === null || v === undefined ? '' : v).replace(',', '.'))
            return isNaN(n) ? 0 : n
        },
        /**
         * Máscara posicional de dinheiro, igual à da grade da folha de ponto: os
         * dígitos entram pela direita e empurram os anteriores.
         * 1 -> 0,01 | 12 -> 0,12 | 125 -> 1,25 | 125000 -> 1.250,00
         *
         * Tudo que não é dígito é descartado, então não há como digitar texto.
         */
        digitarValor () {
            this.form.valor_unitario = this.aplicarMascaraDinheiro(this.form.valor_unitario)
        },
        aplicarMascaraDinheiro (valor) {
            const digitos = String(valor === null || valor === undefined ? '' : valor)
                .replace(/\D/g, '')
                .slice(-11)

            if (!digitos) return ''

            const d = digitos.padStart(3, '0')

            return `${this.milhar(d.slice(0, -2))},${d.slice(-2)}`
        },
        milhar (inteiro) {
            return String(Number(inteiro)).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        /** O campo já vem mascarado: o ponto é separador de milhar, não decimal. */
        numeroDinheiro (v) {
            const texto = String(v === null || v === undefined ? '' : v)
                .replace(/\./g, '')
                .replace(',', '.')

            const n = Number(texto)

            return isNaN(n) ? 0 : n
        },
        formataDinheiro (v) {
            return 'R$ ' + (Number(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        /** No select o que importa é quanto existe: "Produto um - (20 un)". */
        rotuloProduto (p) {
            const unidade = String(p.unidade_medida || 'UN').toLowerCase()
            return `${p.nome} - (${this.formataQtd(p.saldo)} ${unidade})`
        },
        formataData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },


        abrirExclusao (m) {
            this.exclusao = { aberto: true, salvando: false, mov: m, motivo: '' }
        },
        confirmarExclusao () {
            const x = this.exclusao
            if (!x.motivo.trim()) { this.aviso('Informe o motivo da exclusão.'); return }

            x.salvando = true
            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/entrada/${x.mov.id}/excluir`, { motivo: x.motivo }, this.auth())
                .then(r => {
                    x.salvando = false
                    if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                    window.eventBus.$emit('alert', { msg: 'Entrada excluída.', type: 'success' })
                    x.aberto = false
                    this.carregarMovimentos()
                })
                .catch(err => { x.salvando = false; this.$store.commit('throwException', err) })
        },
        rotuloCampo (c) {
            return ({ quantidade: 'Quantidade', valor_unitario: 'Valor unitário', documento: 'Documento', data_movimento: 'Data',
                fornecedor_id: 'Fornecedor', lote: 'Lote', validade: 'Validade', observacao: 'Observação' })[c] || c
        },
        abrirEdicao (m) {
            const qtd = String(Number(m.quantidade)).replace('.', ',')
            const valor = m.valor_unitario ? this.aplicarMascaraDinheiro(Number(m.valor_unitario).toFixed(2).replace('.', '')) : ''
            const form = {
                data_movimento: m.data_movimento ? String(m.data_movimento).substr(0, 10) : '',
                documento: m.documento || '',
                fornecedor_id: m.fornecedor_id || null,
                quantidade: qtd,
                valor_unitario: valor,
                lote: m.lote || '',
                validade: m.validade ? String(m.validade).substr(0, 10) : null,
                observacao: m.observacao || ''
            }
            this.edicao = { aberto: true, salvando: false, mov: m, form, orig: Object.assign({}, form), motivo: '', historico: [] }

            this.$axios.get(`${this.baseUrl()}/api/almox-estoque/entrada/${m.id}/historico`, this.auth())
                .then(r => { this.edicao.historico = r.data || [] })
                .catch(e => this.$store.commit('throwException', e))
        },
        salvarEdicao () {
            const e = this.edicao
            if (!e.motivo.trim()) { this.aviso('Informe o motivo da alteração.'); return }
            if (!(this.numero(e.form.quantidade) > 0)) { this.aviso('Informe uma quantidade maior que zero.'); return }

            // Só vai o que mudou: o valor é mascarado em centavos e não deve sobrescrever casas extras sem querer.
            const payload = { motivo: e.motivo }
            Object.keys(e.form).forEach(k => {
                if (String(e.form[k] === null ? '' : e.form[k]) === String(e.orig[k] === null ? '' : e.orig[k])) return
                if (k === 'quantidade') payload[k] = this.numero(e.form[k])
                else if (k === 'valor_unitario') payload[k] = this.numeroDinheiro(e.form[k]) || null
                else payload[k] = e.form[k] === '' ? null : e.form[k]
            })

            if (Object.keys(payload).length === 1) { this.aviso('Nenhuma alteração informada.'); return }

            e.salvando = true
            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/entrada/${e.mov.id}/editar`, payload, this.auth())
                .then(r => {
                    e.salvando = false
                    if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                    window.eventBus.$emit('alert', { msg: 'Entrada atualizada.', type: 'success' })
                    e.aberto = false
                    this.carregarMovimentos()
                })
                .catch(err => { e.salvando = false; this.$store.commit('throwException', err) })
        },

        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll?situacao=true`, this.auth())
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        carregarFornecedores () {
            this.$axios.get(`${this.baseUrl()}/api/almox-fornecedor/getAll?situacao=true`, this.auth())
                .then(r => { this.fornecedores = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        carregarMovimentos () {
            this.carregando = true
            const filtro = { tipo: 1 }
            if (!this.ehSmed) filtro.instituicao_id = this.$store.state.config.instituicao.id

            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/movimentos`, filtro, this.auth())
                .then(r => { this.movimentos = (r.data && r.data.data) || []; this.carregando = false })
                .catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        buscarProduto (termo) {
            const busca = (termo || '').trim()
            if (!this.grupoId && busca.length < 2) { this.produtos = []; return }

            this.buscando = true
            this.$axios.post(`${this.baseUrl()}/api/almox-produto/buscar`,
                { grupo_id: this.grupoId || null, busca, instituicao_id: this.form.instituicao_id, limite: 30 }, this.auth())
                .then(r => { this.produtos = r.data || []; this.buscando = false })
                .catch(e => { this.buscando = false; this.$store.commit('throwException', e) })
        },
        trocarGrupo () { this.limparProduto(); if (this.grupoId) this.buscarProduto('') },
        selecionarProduto (id) { this.produto = this.produtos.find(p => p.id === id) || null },
        limparProduto () { this.produtos = []; this.produto = null; this.form.produto_id = null },

        salvar () {
            this.$refs.form.validate(valid => {
                if (!valid) { this.aviso('Preencha os campos obrigatórios.'); return }

                const qtd = this.numero(this.form.quantidade)
                if (!(qtd > 0)) { this.aviso('Informe uma quantidade maior que zero.'); return }

                const valor = this.numeroDinheiro(this.form.valor_unitario)

                window.eventBus.$emit('loading', true)

                this.$axios.post(`${this.baseUrl()}/api/almox-estoque/entrada`,
                    Object.assign({}, this.form, {
                        quantidade: qtd,
                        // Sem valor informado, grava nulo em vez de zero: zero seria
                        // "custou nada", nulo é "não sei".
                        valor_unitario: valor > 0 ? valor : null
                    }), this.auth())
                    .then(r => {
                        window.eventBus.$emit('loading', false)
                        if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                        window.eventBus.$emit('alert', { msg: 'Entrada registrada com sucesso.', type: 'success' })
                        this.form.quantidade = ''
                        this.form.valor_unitario = ''
                        this.form.lote = ''
                        this.form.validade = null
                        this.limparProduto()
                        this.carregarMovimentos()
                    })
                    .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
